var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-type-card-container",class:{ 'active': this.data.isActive }},[_c('div',{staticClass:"icon-container"},[_c('div',{staticClass:"icon-content"},[_c('i',{class:_vm.data.icon})])]),_c('div',{staticClass:"text-container"},[_vm._v(" "+_vm._s(_vm.data.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }